import { isSMAManagerFeeExcluded } from '../../utils';

export default {
  name: 'historic-max-fee-metadata-mixin',
  computed: {
    maxDiscountDescription() {
      if (!this.schedule.annualFeeNoLessThan || !this.schedule.allowMaxDiscount) {
        return this.translate('noDiscountAllowed');
      }
      return this.translate('annualFeeNoLessThanMeta', {
        noLessThan: this.formatNumber(this.schedule.annualFeeNoLessThan, 'shortDecimal'),
      });
    },
    isSMAManagerFeeExcluded() {
      return isSMAManagerFeeExcluded(this.schedule);
    },
    SMAFeeExcludedDescription() {
      return this.translate('smaMetadata');
    },
  },
};
